import { useReducer, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { IconAngleDownBold } from '../../assets/icons'

const itemReducer = (state, action) => {
    switch (action.type) {
        case 'TOP_ITEM_CLICK':
            return {
                ...state,
                active: !state.active,
            }
        case 'SUB_ITEM_CLICK':
            return {
                ...state,
                active: action.active,
            }
        case 'OFF_CLICK':
            return {
                ...state,
                active: false,
            }
        default:
            return state
    }
}

const MenuItem = ({ id, label, subMenu, link }) => {
    const [itemState, dispatch] = useReducer(itemReducer, {
        active: false,
        target: null,
        id: id,
    })
    const { active } = itemState

    const topItemHandler = (e) => {
        dispatch({
            type: 'TOP_ITEM_CLICK',
            active:
                e.target.getAttribute('data-menuitem-active') === 'true'
                    ? true
                    : false
        })
    }

    const subItemHandler = (e) => {
        dispatch({
            type: 'SUB_ITEM_CLICK',
            active:
                e.target.getAttribute('data-menuitem-active') === 'true'
                    ? true
                    : false
        })
    }

    const offClickHandler = (e) => {
        dispatch({
            type: 'OFF_CLICK',
            active: false
        })
    }

    const clickHandler = (e) => {
        const clicked = e.target
        const offClick = !clicked.closest(`#${id}`) || (
            !clicked.classList.contains('menu-item') &&
            !clicked.closest('.menu-item')
        )

        if (offClick) {
            offClickHandler(e)
        }
    }

    useEffect(() => {
        const root = document.getElementById('root')
        root.addEventListener('click', clickHandler)

        return () => {
            root.removeEventListener('click', clickHandler)
        }
    })

    return (
        <li className="menu-item" id={id}>
            {link ? (
                <Link
                    to={link}
                    data-menuitem-active={active}
                    onClick={topItemHandler}
                >
                    {label}
                </Link>
            ) : (
                <>
                    <span
                        className="main-header-nav-submenu-trigger"
                        data-menuitem-active={active}
                        onClick={topItemHandler}
                    >
                        {label}
                        <IconAngleDownBold
                            iconClass={`main-header-nav-submenu-trigger-icon ${active ? 'active' : ''}`}
                        />
                    </span>
                    {subMenu && active && (
                        <ul className="main-header-sub-menu">
                            {subMenu.items.map((subItem) => (
                                <li
                                    key={`${subItem.label}-${subItem.link}`}
                                    className={`submenu-item text-link text-link-white ${subItem.className}`}
                                    onClick={subItemHandler}
                                >
                                    <Link to={subItem.link}>
                                        {subItem.label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    )}
                </>
            )}
        </li>
    )
}

export default MenuItem
